import { Injectable } from '@angular/core';
import { BehaviorSubject, catchError, map, Observable, of } from 'rxjs';
import { APIResponse } from '../models/apiResponse';
import { HttpClient } from '@angular/common/http';
import { OcadoAuthService } from './auth.service';
import { promotionConstants } from '../ocado-constants';
import { Lov, Rule } from '../../promotion-details/models/lov';
import { DatePipe } from '@angular/common';
import { environment } from '../../../environments/environment';
import { FormGroup, FormControl } from '@angular/forms';
import { CustomerGroupFormGroup } from '../../promotion-details/models/promotionFormGroup';
import { CustomerGroup } from '../../summary/models/proposal';
import { Filtration, LovReq } from '../../summary/models/filter';

@Injectable({
  providedIn: 'root'
})
export class SharedService {

  promotionName = new BehaviorSubject<ProposalId[]>([]);
  newTab = new BehaviorSubject<any>(null);
  deleteTab = new BehaviorSubject<boolean>(false);
  currentViewId = new BehaviorSubject<number>(-1);
  checkFormChange = new BehaviorSubject<boolean>(false);
  invalidProposal = new BehaviorSubject<boolean>(false);
  openNotificationTab = new BehaviorSubject<boolean>(false);
  openWizard = new BehaviorSubject<any>({});
  public activeApplicationDetails = new BehaviorSubject<any>({});
  public comments!: BehaviorSubject<any[]>;
  private drawerDataList!: BehaviorSubject<any[]>;
  private customerGroupList!: BehaviorSubject<any[]>;
  private productGrpList!: BehaviorSubject<Lov[]>;
  private customerGrpList!: BehaviorSubject<Lov[]>;
  private targetCustGrpList!: BehaviorSubject<Lov[]>;
  private assignCaList!: BehaviorSubject<any[]>;
  public showSkuList: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(true);
  public summaryGridrowCount: BehaviorSubject<number> = new BehaviorSubject<number>(0);
  public commercialList: BehaviorSubject<any[]> = new BehaviorSubject<any[]>([]);
  public isCancelClone: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  public tabLimitExceed: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  public masterDataBaseUrl = '';
  public dashboardBaseUrl = '';
  public proposalBaseUrl = '';
  public promotionBaseUrl = '';
  public authBaseUrl = '';
  public uploadDownloadBaseUrl = '';
  public customerGroupUrl = '';
  private dataStore: {
    drawerData: any[],
    assignCa: any[],
    commercialDataList: any[],
    customerGroups: any[],
    prodGrpList: Lov[],
    custGrpList: Lov[],
    targetCustGrpList: Lov[];
  };

  constructor(private http: HttpClient, private authService: OcadoAuthService, private datePipe: DatePipe) {
    this.comments = new BehaviorSubject<any[]>([]);
    this.masterDataBaseUrl = environment.masterDataBaseUrl;
    this.dashboardBaseUrl = environment.dashboardBaseUrl;
    this.proposalBaseUrl = environment.proposalBaseUrl;
    this.promotionBaseUrl = environment.promotionBaseUrl;
    this.authBaseUrl = environment.authBaseUrl;
    this.uploadDownloadBaseUrl = environment.uploadDownloadBaseUrl;
    this.customerGroupUrl = environment.customerGroupUrl;
    this.dataStore = {
      drawerData: [], assignCa: [], commercialDataList: [], customerGroups: [], prodGrpList: [], custGrpList: [], targetCustGrpList: []
    };
    this.drawerDataList = new BehaviorSubject<any[]>([]);
    this.customerGroupList = new BehaviorSubject<any[]>([]);
    this.assignCaList = new BehaviorSubject<any[]>([]);
    this.productGrpList = new BehaviorSubject<Lov[]>([]);
    this.customerGrpList = new BehaviorSubject<Lov[]>([]);
    this.targetCustGrpList = new BehaviorSubject<Lov[]>([]);
  }

  addComment(newComment: any) {
    const url = `${this.dashboardBaseUrl}comment`;
    return this.http.post<APIResponse>(url, newComment).pipe(
      map((data) => {
        if (data.status) {
          const comment = {
            ...data.result,
            created_by_name: newComment.created_by_name,
            created_by_profile_pic: newComment.created_by_profile_pic
          };
          this.comments.next([ comment, ... this.comments.value ]);
        }
      })).pipe(catchError((err) => of({ result: {}, code: err.error.error })));
  }


  getApplicationList() {
    const url = this.masterDataBaseUrl + 'waffle';
    return this.http.get<APIResponse>(url);
  }

  fetchDrawerData(id: any, entity_type: string) {
    let url = '';
    let payload: any = {};
    if (entity_type === 'PRP') {
      url = this.proposalBaseUrl + 'proposal/get-detail';
      payload = {
        "proposal_id": [
          id
        ],
        "source": "SUMMARY"
      };
    } else {
      url = this.promotionBaseUrl + 'promotion/get-detail';
      payload = {
        "promotion_id": [
          id
        ],
        "source": "SUMMARY"
      };
    }
    this.http.post<APIResponse>(url, payload).subscribe((data: APIResponse) => {
      this.dataStore.drawerData = data.result;
      this.drawerDataList.next(Object.assign({}, this.dataStore).drawerData);
    });
  }
  fetchCaList(ca_id: string = '') {
    const url = this.authBaseUrl + 'authorised-user/Ca-name?' + 'ca_id=' + ca_id;
    this.http.get<APIResponse>(url).subscribe((data: APIResponse) => {
      this.dataStore.assignCa = data.result;
      this.assignCaList.next(Object.assign({}, this.dataStore).assignCa);
    });
  }
  fetchCustomerGroups(filterQuery: Filtration) {
    const url = this.customerGroupUrl + 'customer-group/get';
    return this.http.post<any>(url, filterQuery).subscribe((data: APIResponse) => {
      this.dataStore.customerGroups = data.result.map((item: { customer_group_name: any; customer_group_id: any; }) => ({
        Name: item.customer_group_name,
        Code: item.customer_group_id
      }));
      this.customerGroupList.next(Object.assign({}, this.dataStore).customerGroups);
    });
  }

  fetchProductGroupList(lovReq: LovReq) {
    const url = this.masterDataBaseUrl + 'lov';
    return this.http.post<APIResponse>(url, lovReq).subscribe((data: APIResponse) => {
      this.dataStore.prodGrpList = data.result;
      this.productGrpList.next(Object.assign({}, this.dataStore).prodGrpList);
    });
  }
  fetchCustomerGroupList(lovReq: LovReq) {
    const url = this.masterDataBaseUrl + 'lov';
    return this.http.post<APIResponse>(url, lovReq).subscribe((data: APIResponse) => {
      this.dataStore.custGrpList = data.result;
      this.customerGrpList.next(Object.assign({}, this.dataStore).custGrpList);
    });
  }
  fetchTargetCustomerGroupList(lovReq: LovReq) {
    const url = this.masterDataBaseUrl + 'lov';
    return this.http.post<APIResponse>(url, lovReq).subscribe((data: APIResponse) => {
      this.dataStore.targetCustGrpList = data.result;
      this.targetCustGrpList.next(Object.assign({}, this.dataStore).targetCustGrpList);
    });
  }
  deleteComment(reqBody: any) {
    const url = this.dashboardBaseUrl + 'comment/delete-comment';
    return this.http.post<APIResponse>(url, reqBody);
  }
  fetchAssignCaMentionUsers(caID: string, entityType: string = 'ASN') {

    const url = this.authBaseUrl + "authorised-user/mention-user-details?entity_type=" + entityType + "&ca_id=" + caID;
    return this.http.get<APIResponse>(url);
  }
  doUnassignCA(data: any) {
    const url = this.authBaseUrl + 'authorised-user/unassign-ca';
    return this.http.post<APIResponse>(url, { data });
  }

  fetchCommercialView(entity_id: any, entity_type: any) {
    const url = `${this.dashboardBaseUrl}commercial/view?entity_id=${entity_id}&entity_type=${entity_type}`;
    this.http.get<APIResponse>(url).subscribe((data: APIResponse) => {
      this.dataStore.commercialDataList = data.result;
      const commData = Object.assign({}, this.dataStore).commercialDataList;
      this.commercialList.next(commData);
    });
  }

  groupByProduct(items: any[], key: any) {
    return items.reduce(
      (result, item) => ({
        ...result,
        [ item[ key ] ]: [
          ...(result[ item[ key ] ] || []),
          item,
        ],
      }),
      {},
    );
  }

  duplicateResetSessionStorageSearch(invalidProducts: any, promotionFromGroup: any, currentIndex: number, id: string) {
    if (invalidProducts.filter((e: any) => e.type === 'duplicate').length > 0) {
      this.resetSessionStorageSearch(promotionFromGroup.get(id)?.value || '');
    } else {
      this.resetSessionStorageSearchAtIndex(currentIndex, promotionFromGroup.get(id)?.value || '');
    }
  }

  resetSessionStorageSearch(id: any) {
    const keys = (Object.keys(sessionStorage)).filter(value => (value.endsWith('search') || value.endsWith('showErrorsOnly') || value.includes('search_key')) && value.startsWith(id));
    keys.forEach(value => {
      sessionStorage.removeItem(value);
    });
  }
  resetSessionStorageSearchAtIndex(index: number, id: string) {
    if (sessionStorage.getItem(id + 'g' + index + 'search')) {
      sessionStorage.removeItem(id + 'g' + index + 'search');
    }
    if (sessionStorage.getItem(id + 'search_key' + index)) {
      sessionStorage.removeItem(id + 'search_key' + index);
    }
    if (sessionStorage.getItem(id + 'g' + index + 'showErrorsOnly') === 'true') {
      sessionStorage.removeItem(id + 'g' + index + 'showErrorsOnly');
    }
  }
  resetOcadoSkuColor(promotionFormGroup: any, index: number, id: string) {
    const searchValue = sessionStorage.getItem(promotionFormGroup.get(id)?.value + 'g' + index + 'search');
    if (searchValue && searchValue.length > 0) return true;
    const errorValue = sessionStorage.getItem(promotionFormGroup.get(id)?.value + 'g' + index + 'showErrorsOnly');
    if (errorValue && errorValue === 'true') return true;
    return false;
  }
  numberCoversion(num: number) {
    if (!num.toString().includes('.') || +num.toString().split('.')[ 1 ].length < 3) {
      return num;
    } else {
      if (+num.toString().split('.')[ 1 ].charAt(2) > 0) {
        if (num > 0) {
          return +(num + 0.01).toString().slice(0, num.toString().indexOf('.') + 3);
        } else {
          return +(num).toString().slice(0, num.toString().indexOf('.') + 3);
        }
      } else {
        return +(num).toString().slice(0, num.toString().indexOf('.') + 3);
      }
    }
  }

  generateShortAndLongDesription(data: any, rule: Rule, lovTokens: Lov[], entityType: string = 'PRM') {
    const Description: any = {};
    // pass json data which we are using for create/update promotion/proposal
    const formated_data = this.createFormattedDataForDescription(data);
    if (data.promotion_message !== "" && data.promotion_message !== null && entityType === 'PRP' && ((data.promotion_type === 'Text' && data.promotion_sub_type_name === 'Custom') || data.promotion_type === 'Comb')) {
      Description.short_description_translated = this.applyCustomShortRules(data);
    } else {

      // decode the customized rules
      rule.short_description = this.getNewShortDescription(rule.short_description, formated_data, data.promotion_type, data.mechanic_type, data.promotion_sub_type, data.promotion_start_date, data.promotion_end_date, promotionConstants.Description_Type.Short);

      rule.long_description = this.getNewShortDescription(rule.long_description, formated_data, data.promotion_type, data.mechanic_type, data.promotion_sub_type, data.promotion_start_date, data.promotion_end_date, promotionConstants.Description_Type.Long);

      Description.short_description = rule.short_description;
      Description.long_description = rule.long_description;

      //decode lov tokens
      const translatedValues = this.getShortDescrTranslated(rule.short_description, formated_data, data.promotion_type, lovTokens);
      Description.short_description_translated = translatedValues.desc_translated;
      Description.short_desc_color = translatedValues.desc_color;

    }

    const translatedValues = this.getShortDescrTranslated(rule.long_description, formated_data, data.promotion_type, lovTokens);
    Description.long_description_translated = translatedValues.desc_translated;
    Description.long_desc_color = translatedValues.desc_color;
    // }
    return Description;

  }

  public applyCustomShortRules(data: any) {
    let customShortDesc: string = '';
    const customMsg = data.promotion_message;
    if (data.promotion_type === 'Text' && data.promotion_sub_type_name === 'Custom') {
      customShortDesc = customMsg;

    } else {

      if (data.mechanic_type === promotionConstants.Proposal_Mechanic_Type_Obj.FIX) {
        customShortDesc = (customMsg + ' only £' + Number(data.reward_amount));
      } else if (data.mechanic_type === promotionConstants.Proposal_Mechanic_Type_Obj.DISC || data.mechanic_type === promotionConstants.Proposal_Mechanic_Type_Obj.POFF) {
        const msg = data.mechanic_type === promotionConstants.Proposal_Mechanic_Type_Obj.DISC ? (', Save £' + Number(data.reward_amount)) : (', Save ' + Number(data.reward_amount) + '%');
        customShortDesc = (customMsg + msg);
      } else if (data.mechanic_type === promotionConstants.Proposal_Mechanic_Type_Obj.FREE) {
        const freeChecked = data.p_groups.filter((grps: any) => (grps.p_group_type === 'R' && grps.crud_status !== 'DELETE')) || [];
        let decoded: string = '';
        if (freeChecked.length) {
          const grpName = freeChecked[ 0 ]?.p_group_name;
          decoded = decoded + grpName;
        }
        customShortDesc = (customMsg + (', get ' + decoded + ' free'));
      }
    }
    return customShortDesc;
  }

  public getNewShortDescription = (
    short_description: any,
    data: any,
    promotion_type: any,
    mechanic_type: any,
    sub_type: any,
    promotion_start_date: any,
    promotion_end_date: any,
    description_type: any
  ) => {
    if (
      promotion_type === promotionConstants.Proposal_Type_Obj.Redu &&
      mechanic_type === promotionConstants.Proposal_Mechanic_Type_Obj.POFF
      // && description_type === promotionConstants.Description_Type.Short
    ) {
      const reward_value = data[ promotionConstants.Description_KeyWord_Match.reward ];
      short_description =
        reward_value == promotionConstants.Redu_Poff_Short_Variation.fifty_value
          ?
          // `${!promotionConstants.Offer_Sub_Type.includes(sub_type) &&
          //   description_type === promotionConstants.Description_Type.Short
          //   ? `${promotionConstants.Redu_Poff_Short_Variation.fifty}`
          //   :
          `${short_description.replace(
            `${promotionConstants.Redu_Poff_Long_Variation.replace}`,
            `${promotionConstants.Redu_Poff_Long_Variation.fifty}`
          )}`
          // }`
          : reward_value ==
            promotionConstants.Redu_Poff_Short_Variation.thirtythree_value
            ?
            //  `${!promotionConstants.Offer_Sub_Type.includes(sub_type) &&
            //   description_type === promotionConstants.Description_Type.Short
            //   ? `${promotionConstants.Redu_Poff_Short_Variation.thirtythree}`
            //   :
            `${short_description.replace(
              `${promotionConstants.Redu_Poff_Long_Variation.replace}`,
              `${promotionConstants.Redu_Poff_Long_Variation.thirtythree}`
            )}`
            // }`
            : short_description;
    }

    if (promotion_type === promotionConstants.Proposal_Type_Obj.Mult) {
      if (
        mechanic_type === promotionConstants.Proposal_Mechanic_Type_Obj.POFF
        // && description_type === promotionConstants.Description_Type.Short
      ) {
        const reward_value = data[ promotionConstants.Description_KeyWord_Match.reward ];
        short_description =
          reward_value == promotionConstants.Mult_Poff_Short_Variation.fifty_value
            ? `${promotionConstants.Offer_Sub_Type.includes(sub_type)
              ? `${promotionConstants.Offer_Sub_Type_Name[ sub_type ]} : ${promotionConstants.Mult_Poff_Short_Variation.fifty}`
              : `${promotionConstants.Mult_Poff_Short_Variation.fifty}`
            }
              ${description_type === promotionConstants.Description_Type.Long ? ` ${promotionConstants.Mult_Long_Desc_Postfix}` : ''}`
            : reward_value ==
              promotionConstants.Mult_Poff_Short_Variation.thirtythree_value
              ? `${promotionConstants.Offer_Sub_Type.includes(sub_type)
                ? `${promotionConstants.Offer_Sub_Type_Name[ sub_type ]} : ${promotionConstants.Mult_Poff_Short_Variation.thirtythree}`
                : `${promotionConstants.Mult_Poff_Short_Variation.thirtythree}`
              }${description_type === promotionConstants.Description_Type.Long ? ` ${promotionConstants.Mult_Long_Desc_Postfix}` : ''}`
              : reward_value ==
                promotionConstants.Mult_Poff_Short_Variation.twetyfive_value &&
                data[ promotionConstants.Description_KeyWord_Match.trigger_quantity ] ==
                2
                ? `${promotionConstants.Offer_Sub_Type.includes(sub_type)
                  ? `${promotionConstants.Offer_Sub_Type_Name[ sub_type ]} : ${promotionConstants.Mult_Poff_Short_Variation.twntyfive}`
                  : `${promotionConstants.Mult_Poff_Short_Variation.twntyfive}`
                }${description_type === promotionConstants.Description_Type.Long ? ` ${promotionConstants.Mult_Long_Desc_Postfix}` : ''}`
                : short_description;
      }

      if (
        mechanic_type === promotionConstants.Proposal_Mechanic_Type_Obj.FREE &&
        description_type === promotionConstants.Description_Type.Short
      ) {
        short_description =
          data[ promotionConstants.Description_KeyWord_Match.reward ] == 1 &&
            data[ promotionConstants.Description_KeyWord_Match.trigger_quantity ] == 2
            ? `${promotionConstants.Offer_Sub_Type.includes(sub_type)
              ? `${promotionConstants.Offer_Sub_Type_Name[ sub_type ]} : ${promotionConstants.Mult_Free_Short_Variation.TQ_two_Reward_one}`
              : promotionConstants.Mult_Free_Short_Variation.TQ_two_Reward_one
            }`
            // : data[ promotionConstants.Description_KeyWord_Match.reward ] == 1 &&
            //   data[ promotionConstants.Description_KeyWord_Match.trigger_quantity ] == 3
            //   ? `${promotionConstants.Offer_Sub_Type.includes(sub_type)
            //     ? `${promotionConstants.Offer_Sub_Type_Name[ sub_type ]} : ${promotionConstants.Mult_Free_Short_Variation.TQ_three_Reward_one}`
            //     : promotionConstants.Mult_Free_Short_Variation.TQ_three_Reward_one
            //   }`

            // : data[ promotionConstants.Description_KeyWord_Match.reward ] >= 1 &&
            //   data[ promotionConstants.Description_KeyWord_Match.trigger_quantity ] >=
            //   3
            //   ? `${promotionConstants.Offer_Sub_Type.includes(sub_type)
            //     ? `${promotionConstants.Offer_Sub_Type_Name[ sub_type ]} : ${promotionConstants.Mult_Free_Short_Variation.TQ_Reward_Greater_Then_one}`
            //     : promotionConstants.Mult_Free_Short_Variation
            //       .TQ_Reward_Greater_Then_one
            //   }`
            : short_description;
      }

      // if (description_type === Constants.Description_Type.Short) {
      const p_groups = data.p_groups
        .map((x: any) =>
          x.products.filter(
            (x: any) => x.crud_status !== promotionConstants.P_Group_Delete_Crud_Status
          )
        )
        .reduce((a: any, b: any) => a.concat(b), []);
      short_description =
        p_groups.length === 1
          ? short_description.replace(
            promotionConstants.Mult_Short_Variation_Replace.replace_value,
            promotionConstants.Mult_Short_Variation_Replace.replace_with
          )
          : short_description;
      // }
    }

    if (
      // promotion_type === promotionConstants.Proposal_Type_Obj.Bund ||
      promotion_type === promotionConstants.Proposal_Type_Obj.Link ||
      promotion_type === promotionConstants.Proposal_Type_Obj.Comb
    ) {
      const replace_desc = (
        replace_value: string,
        shortDescription: string
      ) => {
        return shortDescription
          .replace(
            promotionConstants.Bund_Comb_Link_Match_Reward_Value.percent,
            replace_value
          )
          .replace(
            promotionConstants.Bund_Comb_Link_Match_Reward_Value.pound,
            replace_value
          );
      };
      const reward_value = data[ promotionConstants.Description_KeyWord_Match.reward ];
      short_description =
        reward_value ==
          promotionConstants.Bund_Comb_Link_Replace_Reward_Value.fifty_value
          ? `${replace_desc(promotionConstants.Bund_Comb_Link_Replace_Reward_Value.fifty, short_description)}`
          : reward_value ==
            promotionConstants.Bund_Comb_Link_Replace_Reward_Value.thirtythree_value
            ? `${replace_desc(promotionConstants.Bund_Comb_Link_Replace_Reward_Value.thirtythree, short_description)}`
            : short_description;
    }

    // if (
    //   promotionConstants.PROPOSAL_TYPE_LONG_DESC_APPEND_DEC.includes(promotion_type) &&
    //   description_type === promotionConstants.Description_Type.Long &&
    //   sub_type !== promotionConstants.Offer_Sub_Type_obj.Clearance
    // ) {
    //   const start_date = this.datePipe.transform(promotionConstants.LONG_DESC_APPEND_OCT_DEC.start_date, 'MM-dd') || '';
    //   const end_date = this.datePipe.transform(promotionConstants.LONG_DESC_APPEND_OCT_DEC.end_date, 'MM-dd') || '';
    //   const prm_start_date = this.datePipe.transform(promotion_start_date, 'MM-dd') || '';
    //   const prm_end_date = this.datePipe.transform(promotion_end_date, 'MM-dd') || '';

    //   if (
    //     // (prm_start_date >= start_date && prm_start_date <= end_date) ||
    //     // (prm_end_date >= start_date && prm_end_date <= end_date)
    //     prm_start_date >= start_date && prm_end_date <= end_date
    //   ) {
    //     short_description = !short_description.includes(promotionConstants.LONG_DESC_APPEND_OCT_DEC.Long_Desc) ? `${short_description} ${promotionConstants.LONG_DESC_APPEND_OCT_DEC.Long_Desc}` : short_description;
    //   } else short_description = short_description.replace(promotionConstants.LONG_DESC_APPEND_OCT_DEC.Long_Desc, '');
    // }

    return short_description;
  };

  public getShortDescrTranslated = (
    short_description: any,
    data: any,
    promotion_type: any,
    lovToken: any
  ) => {
    const lovTokens = lovToken;
    let color_desc = short_description;
    for (let i = 0; i < lovTokens.length; i++) {
      if (short_description?.includes(lovTokens[ i ].lov_code)) {
        const token = lovTokens[ i ].lov_code;
        let key: string = lovTokens[ i ].lov_subcode;
        let value: any = data[ key ];
        if (
          token.toLowerCase()?.includes(promotionConstants.Description_KeyWord_Match.last)
        ) {
          const p_groups = data.p_groups.filter(
            (x: any) =>
              // x.p_group_type === promotionConstants.Proposal_Group_Type_Obj.reward &&
              x.crud_status !== promotionConstants.P_Group_Delete_Crud_Status
          );
          const lastGrpIndex = p_groups.length - 1;
          value = p_groups.length > 0 ? key === promotionConstants.Description_KeyWord_Match.required_quantity_in_basket ? p_groups[ lastGrpIndex ][ key ] > 1 ? p_groups[ lastGrpIndex ][ key ] : "" : p_groups[ lastGrpIndex ][ key ] : token;
        }
        //latest change
        if (
          key.toLowerCase().includes(promotionConstants.Description_KeyWord_Match.minus)
        ) {
          const split_token = key.split(
            promotionConstants.Description_KeyWord_Match.minus
          );
          value =
            data[ split_token[ 0 ] ] -
            (split_token[ 1 ] == promotionConstants.Description_KeyWord_Match.one
              ? 1
              : data[ split_token[ 1 ] ]);
        }

        if (
          token.toLowerCase()?.includes(promotionConstants.Description_KeyWord_Match.all)
        ) {
          const split_token = key.split(" ");
          let values = "";
          const p_groups = data.p_groups.filter(
            (x: any) => x.crud_status !== promotionConstants.P_Group_Delete_Crud_Status
          );
          const group_length = p_groups.length;
          for (const [ pgin, pgval ] of p_groups.entries()) {
            const token_value = split_token.map((x: any) =>
              x ===
                promotionConstants.Description_KeyWord_Match.required_quantity_in_basket
                ? pgval[ x ] > 1
                  ? pgval[ x ]
                  : null
                : pgval[ x ]
            );
            values += `${token_value.filter((n: any) => n).join(" ").trim()}${group_length - 1 > pgin ? (group_length - 2 === pgin ? " and " : ", ") : ""}`;
            value = values;
          }
        }

        if (
          token.toLowerCase()?.includes(promotionConstants.Description_KeyWord_Match.buy)
        ) {
          const split_token = key.split(" ");
          let values = "";
          const p_groups = data.p_groups.filter(
            (x: any) =>
              x.p_group_type === promotionConstants.Proposal_Group_Type_Obj.buy &&
              x.crud_status !== promotionConstants.P_Group_Delete_Crud_Status
          );
          const group_length = p_groups.length;
          for (const [ pgin, pgval ] of p_groups.entries()) {
            const token_value = split_token.map((x: any) =>
              x ===
                promotionConstants.Description_KeyWord_Match.required_quantity_in_basket
                ? pgval[ x ] > 1
                  ? pgval[ x ]
                  : null
                : pgval[ x ]
            );
            values += `${token_value.filter((n: any) => n).join(" ").trim()}${group_length - 1 > pgin ? ", " : ""}`;
            value = values;
          }
        }

        if (promotionConstants.Date_Column_Names?.includes(key)) {
          value = new DatePipe("en-US").transform(new Date(value || ''), promotionConstants.britishDateFormat);
        }

        if (promotionConstants.Convert_to_Int_Column_Names.includes(key)) {
          value = parseInt(value);
        }

        if (
          key.includes(promotionConstants.Description_KeyWord_Match.current) &&
          data.promotion_id
        ) {
          if (key.includes(promotionConstants.Description_KeyWord_Match.current_promotion_price))
            key = key?.replace(`${promotionConstants.Description_KeyWord_Match.current_promotion_price}`, `${promotionConstants.Description_KeyWord_Match.effective_promo_price}`);
          else
            key = key?.replace(
              `${promotionConstants.Description_KeyWord_Match.current}`,
              `${promotionConstants.Description_KeyWord_Match.effective}`
            );

          value = data[ key ];
        }
        let ispence = false;
        if (
          promotionConstants.Convert_to_decimal_Column_Names.includes(key) ||
          key.includes(promotionConstants.Description_KeyWord_Match.current) ||
          key.includes(promotionConstants.Description_KeyWord_Match.effective)
        ) {
          value = +value;
          if (value >= 1) {
            value = value.toFixed(Number.isInteger(value) ? 0 : 2);
          } else {
            ispence = true;
            value = this.getPenceValue(value);
          }
        }
        // short_description =
        //   value === undefined || value === null || (value === ""
        //     && !token.toLowerCase()?.includes(promotionConstants.Description_KeyWord_Match.req_qty_last)) ?
        //     short_description?.replace(
        //       new RegExp(`${token}`, "g"),
        //       "")
        //     :
        //     promotion_type === promotionConstants.Proposal_Type_Obj.Link &&
        //       key?.includes(
        //         promotionConstants.Description_KeyWord_Match.required_quantity_in_basket
        //       )
        //       ? short_description?.replace(
        //         new RegExp(`${token}`, "g"),
        //         value === 1 ? "" : `${value}`
        //       )
        //       : short_description?.replace(
        //         new RegExp(`${token}`, "g"),
        //         value
        //       );
        if (value === undefined || value === null || (value === '' && !token.toLowerCase()?.includes(promotionConstants.Description_KeyWord_Match.req_qty_last))) {
          short_description = short_description;
        } else if (
          promotion_type === promotionConstants.Proposal_Type_Obj.Link &&
          key.includes(
            promotionConstants.Description_KeyWord_Match.required_quantity_in_basket
          )
        ) {
          if (ispence) {
            short_description = short_description.replace(
              new RegExp(`£${token} `, 'g'),
              value === 1 ? '' : `${value} `
            );
          }
          short_description = short_description.replace(
            new RegExp(`${token} `, 'g'),
            value === 1 ? '' : `${value} `
          );
        } else {
          if (ispence) {
            short_description = short_description.replace(
              new RegExp(`£${token}`, 'g'),
              value
            );
          }
          short_description = short_description.replace(
            new RegExp(`${token}`, 'g'),
            value
          );
        }
        color_desc = color_desc.replace(token, `<span class="right">${token}</span>`);
      }
    }
    let matches = color_desc?.match(/@\S+/g);
    if (matches !== null && matches !== undefined) {
      if (matches) {
        matches = matches.filter((match: string | string[]) => !match.includes('span'));
        matches.forEach((match: any) => {
          const regex = new RegExp(`(${match})`, 'gi');
          color_desc = color_desc.replace(regex, '<span class="highlight">$1</span>');
        });
      }
    }
    return { desc_translated: short_description, desc_color: color_desc };
  };

  public createFormattedDataForDescription = (
    data: any,
    key_name: any = null,
    index: any = null
  ) => {
    let response: any = {};
    if (data) {
      for (const key of Object.keys(data)) {
        if (Array.isArray(data[ key ])) {
          if (index == null) response[ key ] = data[ key ];
          for (const [ i, value ] of key ===
            promotionConstants.Proposal_Response_File_Name.products
            ? [ data[ key ][ 0 ] ].entries()
            : data[ key ].entries()) {
            response = {
              ...response,
              ...(this.createFormattedDataForDescription(
                value,
                `${key_name ? `${key_name}_` : ""}${index != null ? `${index}_` : ""}${key}`,
                i
              )),
            };
          }
          continue;
        }
        const reskey = `${key_name ? `${key_name}_` : ""}${index != null ? `${index}_` : ""}${key}`;
        response[ reskey ] = data[ key ];
      }
    }
    return response;
  };

  public getPenceValue = (number: number) => {
    const decimalPart = Math.abs(number - Math.floor(number));
    const decimalPartString = String(decimalPart.toFixed(2)).split('.')[ 1 ];
    return `${+decimalPartString < 10 ? +decimalPartString : decimalPartString}p`;;
  };

  public fetchDownloadCsv(promotion_id: any): Observable<any> {
    const url = this.uploadDownloadBaseUrl + 'excel/download-csv-promotion';
    return this.http.post<any>(url, promotion_id).pipe(catchError((error) => of({ ...error.error, result: {} as any, code: 'error' })));
  }

  get getDrawerData() {
    return this.drawerDataList;
  }

  get customerGroups() {
    return this.customerGroupList;
  }

  get getComments() {
    return this.comments;
  }
  get getAssignCa() {
    return this.assignCaList;
  }

  get commercialDataList() {
    return this.commercialList;
  }

  get productGroupList() {
    return this.productGrpList;
  }

  get allCustomerGrpList() {
    return this.customerGrpList;
  }

  get targetCustomerGroupList() {
    return this.targetCustGrpList;
  }

}
export interface ProposalId {
  id: string | null;
  name: string | null;
  isEdited: boolean;
}
